import { HiPencil } from "react-icons/hi";
import { IoSettingsOutline } from "react-icons/io5";

const data = [
  {
    id: Math.random() * 10,
    name: "Bill_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Date",
        label: "Bill Date",
        type: "Date",
        min: 0,
        max: Infinity,
        Reference_field: true,
        Reference_field: "financialYear",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "CashOrDebit",
        label: "C/D",
        type: "inputdrop",
        dropdowndata: ["Debit", "Cash"],
        min: 0,
        max: Infinity,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Voucher_Series",
      //   label: "Book Code ",
      //   masterName: "Voucher_Series",
      //   // dropdowndata: GetBookCodes,
      //   variable: {
      //     Voucher_Type: "Sales Bill",
      //   },
      //   type: "InputDropForQuery",
      // },
      {
        id: Math.random() * 10,
        name: "Invoice_No",
        label: "Bill No",
        type: "text",
        icon: "IoSettingsOutline",
        disabled: true,
        // min: 5,
        // max: 5,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Voucher_Mode",
      //   label: "Voucher Mode",
      //   type: "inputdrop",
      //   dropdowndata: ["Item Invoice", "Accounting Entry"],
      //   min: 0,
      //   max: Infinity,
      //   isRequired: true,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Tax",
      //   label: "Tax",
      //   type: "inputdrop",
      //   dropdowndata: ["Line Itemwise", "Common"],
      //   min: 0,
      //   max: Infinity,
      //   isRequired: true,
      // },
      {
        id: Math.random() * 10,
        name: "Tax_Group",
        Reference_field: ["Party", ""],
        label: "Tax",
        dependOn: {
          section: "FormConfiguration",
          name: "Tax",
          visibleOn: "Common",
        },
        masterName: "SalesInvoiceType",
        type: "InputDropForQuery",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Party",
        label: "Party Account",
        masterName: "Customer_Account_From_Account_Balance",
        variable: {
          accountType: ["Customer Account"],
        },
        type: "InputDropForQuery",
        isRequired: true,
        min: 0,
        max: Infinity,
        break: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Sales_Account_Selection",
      //   label: "Sales Account Selection",
      //   type: "inputdrop",
      //   dropdowndata: ["Line Itemwise", "Common"],
      //   min: 0,
      //   max: Infinity,
      //   isRequired: true,
      // },
      {
        // dependOn: {
        //   section: "Bill_Details",
        //   name: "Sales_Account_Selection",
        //   visibleOn: "Common",
        // },
        id: Math.random() * 10,
        name: "Account",
        label: "Sales Account",
        variable: {
          accountType: ["General Account"],
          // accountGroup: "Sales",
        },
        dependOn: {
          section: "FormConfiguration",
          name: "Sales_Account_Selection",
          visibleOn: "Common",
        },
        masterName: "General_Account",
        type: "InputDropForQuery",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "RCM",
        label: "RCM",
        type: "checkbox",
        // dropdowndata: ["YES", "NO"],
        disableDependOn: {
          section: "Bill_Details",
          name: "Party",
          disableOn: "GST_Number",
          value: false,
        },
        min: 0,
        max: Infinity,
        disabled: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Tax_Type",
      //   label: "Tax Type",
      //   type: "text",
      //   min: 0,
      //   max: Infinity,
      //   disabled: true,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Ref_No",
      //   label: "Reference No",
      //   type: "text",
      //   min: 0,
      //   max: Infinity,
      //   disabled: true,
      // },
    ],
  },
];

const fields1 = [
  {
    id: Math.random() * 10,
    name: "Stock_Item",
    Input: true,
    type: "InputDropForQuery",
    masterName: "StockItem",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Particular",
    Input: true,
    type: "text",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Tax_Group",
    Reference_field: ["Party", ""],

    Input: true,
    type: "InputDropForQuery",
    masterName: "SalesInvoiceType",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Tax_Rate",
    Input: true,
    type: "Number",
    value: "",
    disabled: true,
  },
  {
    id: Math.random() * 10,
    name: "Tax_Code",
    Input: true,
    type: "InputDropForQuery",
    masterName: "Tax_Code",
    value: "",
    isRequired:true,
    // variable: {
    //   isHSN: true,
    //   isSAC: true,
    // },
  },
  {
    id: Math.random() * 10,
    name: "Account",
    Input: true,
    type: "InputDropForQuery",
        isRequired:true,
    variable: {
      accountType: ["General Account"],
      // accountGroup: "Sales",
    },
    masterName: "General_Account",
    value: "",
  },

  {
    id: Math.random() * 10,
    name: "Quantity",
    label: "Quantity",
    Input: true,
    type: "Number",
    value: "",
    onlyPositive: true,
  },
  {
    id: Math.random() * 10,
    name: "Item_Value",
    label: "Rate",
    Input: true,
    type: "Number",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Amount",
    label: "Amount",
    Input: true,
    type: "Number",
    value: "",
    disabled: true,
  },
];
const fields2 = [
  {
    id: Math.random() * 10,
    name: "Particular",
    Input: true,
    type: "text",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Tax_Group",
    Reference_field: ["Party", ""],

    Input: true,
    type: "InputDropForQuery",
    masterName: "SalesInvoiceType",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Tax_Rate",
    Input: true,
    type: "Number",
    value: "",
    disabled: true,
  },
  {
    id: Math.random() * 10,
    name: "Tax_Code",
    Input: true,
    type: "InputDropForQuery",
    masterName: "Tax_Code",
    isRequired:true,
    value: "",
    // variable: {
    //   isHSN: true,
    //   isSAC: true,
    // },
  },
  {
    id: Math.random() * 10,
    name: "Account",
    Input: true,
    type: "InputDropForQuery",
    isRequired:true,
    variable: {
      accountType: ["General Account"],
      // accountGroup: "Sales",
    },
    masterName: "General_Account",
    value: "",
  },

  {
    id: Math.random() * 10,
    name: "Quantity",
    label: "Quantity",
    Input: true,
    type: "Number",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Item_Value",
    label: "Rate",
    Input: true,
    type: "Number",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Amount",
    label: "Amount",
    Input: true,
    type: "Number",
    value: "",
    disabled: true,
  },
];

const Configuration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Voucher_Mode",
        label: "Voucher Mode",
        type: "inputdrop",
        dropdowndata: ["Item Invoice", "Accounting Entry"],
        min: 0,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Tax",
        label: "Tax",
        type: "inputdrop",
        dropdowndata: ["Line Itemwise", "Common"],
        min: 0,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Sales_Account_Selection",
        label: "Sales Account Selection",
        type: "inputdrop",
        dropdowndata: ["Line Itemwise", "Common"],
        min: 0,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Default_Voucher_Series",
        label: "Default Voucher Series",
        type: "InputDropForQuery",
        masterName: "Voucher_Series",
        variable: {
          Voucher_Type: "Sales Bill",
        },
        min: 0,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Discount_Account",
        label: "Discount Account",
        type: "InputDropForQuery",
        variable: {
          accountType: ["General Account"],
        },
        masterName: "General_Account",
      },
      {
        id: Math.random() * 10,
        name: "DefaultApplyRoundOff",
        label: "Default RoundOff",
        type: "Check-Box",
      },
      {
        id: Math.random() * 10,
        name: "termsAndConditions",
        label: "Terms & Conditions",
        type: "Text Box(Multi Line)",

        min: 0,
        max: Infinity,
        isRequired: true,
      },
    ],
  },
];

export const InvoiceNumberConfig = [
  {
    id: Math.random() * 10,
    name: "Book_Code_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Voucher_Series",
        label: "Book Code ",
        masterName: "Voucher_Series",
        // dropdowndata: GetBookCodes,
        variable: {
          Voucher_Type: "Sales Bill",
        },
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Bill_No",
        label: "Next Number",
        type: "Number",

        min: 5,
        max: 5,
      },
    ],
  },
];
const initialHeaders1 = [
  "Item Name",
  "Particular",
  "Tax",
  "Tax Rate",
  "HSN",
  "Sales A/c",
  "Quantity",
  "Rate",
  "Amount",
];
const initialHeaders2 = ["Particular", "Tax", "Tax Rate", "HSN", "Sales A/c", "Quantity", "Rate", "Amount"];

export { data, fields1, fields2, initialHeaders1, initialHeaders2, Configuration };

export const Sales_Bill_Documents = [
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Acknowledgement_Doc",
        label: "Acknowledgement",
      },
      {
        id: Math.random() * 10,
        name: "Invoice_Doc",
        label: "Invoice",
      },
      {
        id: Math.random() * 10,
        name: "E_way_bill_Doc",
        label: "E-way Bill",
      },
      {
        id: Math.random() * 10,
        name: "Doc",
        label: "Doc",
      },
      {
        id: Math.random() * 10,
        name: "File",
        label: "File",
      },
    ],
  },
];
